import { useParams } from "react-router-dom";
import withAuth from "../../components/auth";
import { injectIntl } from "react-intl";


function GamesListSelector(props) {  
  let { id } = useParams();  

  return (
    <div className="content-body">
        <div className="container-fluid">
            <games-list-selector />
        </div>
    </div>
  );
}

export default injectIntl(withAuth(GamesListSelector));